import { FC, ReactElement, useState } from 'react'
import styled from 'styled-components'
import ReactPlayer from 'react-player'
// @ts-ignore
import { Scrollama, Step } from 'react-scrollama'
import SVG, { Props as SVGProps } from 'react-inlinesvg'
import screenfull from 'screenfull'
import { device } from '../breakpoints'

const VideoModule: FC<{
  src: string
  quote: string
  cite: string
  legend: string
}> = ({ src, quote, cite, legend }): ReactElement => {
  const [muted, setMuted] = useState(true)
  const [playing, setPlaying] = useState(false)
  const [player, setPlayer] = useState<ReactPlayer | null>(null)
  const [progress, setProgress] = useState(0)
  const [duration, setDuration] = useState(0)
  const [videoReady, setVideoReady] = useState(false)
  const [videoRef, setVideoRef] = useState<HTMLDivElement | null>(null)

  const handleWaypointEnter = () => {
    console.log('ENTER')
    setPlaying(true)
  }

  const handleWaypointLeave = () => {
    console.log('LEAVE')
    setPlaying(false)
  }

  const handleOnProgress = (e: any) => {
    setProgress(e.played)
  }

  const handleDuration = (duration: number) => {
    setDuration(duration)
  }

  const videoContentSpaceLeft = videoRef
    ? window.innerHeight - videoRef.getBoundingClientRect().height
    : 0

  return (
    <Container>
      <Quote>
        «{quote}»<QuoteLegend>{cite}</QuoteLegend>
      </Quote>

      <Content
        style={{
          marginTop: videoContentSpaceLeft * -0.5,
          marginBottom: videoContentSpaceLeft * -0.5,
        }}
      >
        <Scrollama
          onStepEnter={handleWaypointEnter}
          onStepExit={handleWaypointLeave}
          offset={0}
          // We want to play the video when its middle is in the viewport
          // offset={`${
          //   window.innerHeight / 2 -
          //   (videoContainer
          //     ? videoContainer.getBoundingClientRect().height / 2
          //     : 0)
          // }px`}
        >
          <Step data={1}>
            <VideoContainer>
              <VideoInner ref={setVideoRef}>
                {/* <VideoDummy>
                  <Buttons>
                    <ReplayIcon
                      onClick={() => {
                        if (player) {
                          player.seekTo(0)
                        }
                      }}
                    >
                      <StyledSVG
                        src={require(`./replay-icon.svg`).default}
                        title='Menu'
                        color='#202346'
                      />
                    </ReplayIcon>
                    <UnmuteButtonContainer>
                      <UnmuteButton
                        onClick={() => {
                          if (muted) {
                            setPlaying(true)
                          }
                          setMuted(!muted)
                        }}
                      >
                        <UnmuteButtonIcon>
                          <StyledSVG
                            src={require(`./sound-icon${
                              muted ? '' : '-muted'
                            }.svg`)}
                            title='Menu'
                            color='#202346'
                          />
                        </UnmuteButtonIcon>
                      </UnmuteButton>
                    </UnmuteButtonContainer>
                  </Buttons>
                </VideoDummy> */}
                <VideoPlayer active={playing}>
                  <Buttons>
                    <ReplayIcon
                      onClick={() => {
                        if (player) {
                          player.seekTo(0)
                        }
                      }}
                    >
                      <StyledSVG
                        src={require(`./replay-icon.svg`).default}
                        title='Menu'
                        color='#202346'
                      />
                    </ReplayIcon>
                    <UnmuteButtonContainer>
                      <UnmuteButton
                        onClick={() => {
                          if (muted) {
                            setPlaying(true)
                          }
                          setMuted(!muted)
                        }}
                      >
                        <UnmuteButtonIcon>
                          <StyledSVG
                            src={require(`./sound-icon${
                              muted ? '' : '-muted'
                            }.svg`)}
                            title='Menu'
                            color='#202346'
                          />
                        </UnmuteButtonIcon>
                      </UnmuteButton>
                    </UnmuteButtonContainer>
                  </Buttons>

                  <ReactPlayer
                    onReady={() => {
                      setVideoReady(true)
                    }}
                    onDuration={handleDuration}
                    onProgress={handleOnProgress}
                    ref={setPlayer}
                    height={'auto'}
                    width={'100%'}
                    muted={muted}
                    playsinline
                    playing={playing}
                    url={src}
                    // loop
                  />
                  <PlayStateContainer>
                    <Line progress={progress}></Line>
                  </PlayStateContainer>
                </VideoPlayer>

                <Legend>{legend}</Legend>
              </VideoInner>
            </VideoContainer>
          </Step>
        </Scrollama>
      </Content>
    </Container>
  )
}

const VideoInner = styled.div`
  position: relative;
`

const VideoDummy = styled.div`
  position: relative;
  width: 600px;
  height: 600px;
  background-color: #333333;
`

const UnmuteButtonIcon = styled.div`
  height: 20px;
  line-height: 0;
  display: inline-block;
`

const PlayStateContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
`

const Line = styled.div<{ progress: number }>`
  width: ${({ progress }) => progress * 100}%;
  height: 4px;
  background-color: #ffe462;
`

const StyledSVG = styled(SVG)<SVGProps>`
  height: 100%;
  width: auto;
  & path,
  line,
  circle,
  rect,
  polyline {
    fill: ${({ color }) => color} !important;
    stroke-width: 0;
  }
`

const Buttons = styled.div`
  position: absolute;
  z-index: 1;
  display: flex;
  top: 20px;
  right: 20px;
`

const Container = styled.div`
  position: relative;
  background-color: #222233;
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  min-height: 150vh;
  color: white;
  padding: 60px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Content = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const Legend = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 1.5rem;
  color: #ffffff;
  line-height: 2.1rem;
  display: flex;
  padding-top: 1.5rem;
`

const Quote = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: var(--font-source);
  font-weight: 700;
  line-height: 1.1;
  max-width: 500px;
  padding: 0 40px;
  text-align: center;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-size: 3rem;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-size: 4rem;
  }

  &:before {
    content: '';
    width: 6rem;
    background-color: #ffffff;
    height: 2px;
    display: block;
    opacity: 0.25;
    margin-bottom: 35px;
  }

  &:after {
    content: '';
    width: 6rem;
    background-color: #ffffff;
    height: 2px;
    display: block;
    opacity: 0.25;
    margin-top: 3.5rem;
  }
`

const QuoteLegend = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 1.5rem;
  font-weight: 400;
  opacity: 0.5;
  margin-top: 20px;
`

const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 85vh;
  padding: 20px;
  box-sizing: border-box;
  line-height: 0;
`

const VideoPlayer = styled.div<{ active: boolean }>`
  position: relative;
  transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
  transform: ${({ active }) => (active ? 'scale(1)' : 'scale(0.9)')};
  opacity: ${({ active }) => (active ? '1' : '0.5')};
`

const UnmuteButtonContainer = styled.div`
  position: relative;
`

const UnmuteButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: #ffe462;
  color: #202346;
  border: none;
  outline: none;
  width: 50px;
  height: 50px;
  border-radius: 50px;
  cursor: pointer;
  font-family: var(--font-sans-serif);
  font-size: 0.75em;
  font-weight: 700;
`

const ReplayIcon = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: #ffe462;
  border: none;
  outline: none;
  border-radius: 50px;
  cursor: pointer;
  font-family: var(--font-sans-serif);
  font-size: 0.75em;
  font-weight: 700;
  width: 50px;
  height: 50px;
  margin-right: 10px;

  ${StyledSVG} {
    width: 20px;
    height: auto;
  }
`

export default VideoModule
